import React from 'react';
import { IMAGES, OCCASIONS } from '../data';
import { Reveal } from './Reveal';
export function Occasions() {
  return <section id="tillfallen" className="w-full bg-skog py-28 text-warm md:py-40" data-id="element-145" data-mp="22nby0gtqlaam">
      <div className="mx-auto grid max-w-7xl gap-16 px-6 md:grid-cols-[1fr,1.1fr] md:gap-24 md:px-10" data-id="element-146" data-mp="1ylqfofyfo3t1">
        <div className="md:sticky md:top-32 md:self-start" data-id="element-147" data-mp="1togs75ulu27u">
          <Reveal data-id="element-148" data-mp="2qdocybneg7ap">
            <p className="mb-6 text-[12px] uppercase tracking-wide3 text-smorgul" data-id="element-149" data-mp="2qe7j6v3ot78w">
              För alla tillfällen
            </p>
            <h2 className="font-display text-4xl font-light leading-tight md:text-5xl" data-id="element-150" data-mp="2mddzyf16wgmc">
              Oavsett vad du planerar – så hjälper vi dig att hitta rätt.
            </h2>
          </Reveal>
          <Reveal delay={0.2} data-id="element-151" data-mp="2clhyqv3t4adw">
            <div className="mt-10 overflow-hidden rounded-sm" data-id="element-152" data-mp="2ckgminb21hul">
              <img src={IMAGES.tableCandlelight} alt="Dukat bord med säsongsrätter i levande ljus" className="h-72 w-full object-cover md:h-96" data-id="element-153" data-mp="3a2gng3ii93or" />
            </div>
          </Reveal>
        </div>

        <div data-id="element-154" data-mp="9cqyf6hjqhdp">
          <ul className="flex flex-wrap gap-x-3 gap-y-4" data-id="element-155" data-mp="9djy5ni386mc">
            {OCCASIONS.map((o, i) => <Reveal key={o} delay={Math.min(i * 0.03, 0.4)} data-id="element-156" data-mp="3rrt4m1zpmlbb" data-mpi={i}>
                <li data-id="element-157" data-mp="3rp6vvz131zri">
                  <a href="/utbud" className="inline-block rounded-full border border-warm/25 px-5 py-2.5 text-sm text-warm/90 transition-colors hover:border-smorgul hover:text-smorgul" data-id="element-158" data-mp="3vscxuuh5x4s6">
                    {o}
                  </a>
                </li>
              </Reveal>)}
          </ul>
          
          <Reveal delay={0.5} data-id="element-159" data-mp="38sxbktzl8cz2">
            <div className="mt-12 border-t border-warm/10 pt-8" data-id="element-160" data-mp="38tqa57oe7w64">
              <a href="/utbud" className="group inline-flex items-center gap-3 text-sm uppercase tracking-wide2 text-smorgul transition-colors hover:text-warm" data-id="element-161" data-mp="3csz3ibfits15">
                Se utbud för alla tillfällen
                <svg className="h-4 w-4 transition-transform group-hover:translate-x-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-162" data-mp="1b1cjitu1qxe6">
                  <path strokeLinecap="round" strokeLinelinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" data-id="element-163" data-mp="2jx809aviyga7" />
                </svg>
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>;
}